import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Button, Col, Row } from "reactstrap";
import VideoModal from "./VideoModal";

export default function AboutIcm(props) {
  const [assetDetails, setAssetDetails] = useState(null);
  const { isMobile, mldAssetDetails, productDetails } = props;
  const [showVideo, setShowVideo] = useState(false);
  useEffect(() => {
    setAssetDetails({
      descTitle: props?.mldAssetDetails?.bondId === "mld5" ? "<b>Nature of Business:</b> Diversified NBFC" : null,
      title: "About " + productDetails.productName,
      logoName: productDetails.fundId + " Finserv Limited",
      logo: productDetails.descLogoUrl,
      description: productDetails.description,
      lastArr: [
        get(props, "productDetails.aum", "")
          ? {
              key: "AUM",
              value: get(props, "productDetails.aum", "")
                ? get(props, "productDetails.aum", "")
                : "NA",
            }
          : null,
        get(props, "productDetails.netWorth", "")
          ? {
              key: "NetWorth",
              value: get(props, "productDetails.netWorth", ""),
            }
          : null,
        get(props, "productDetails.marketCap", "")
          ? {
              key: "Market Cap",
              value: get(props, "productDetails.marketCap", ""),
            }
          : null,
        get(props, "productDetails.gnpa", "")
          ? {
              key: "GNPA/NNPA",
              value:
                get(props, "productDetails.gnpa", "") +
                " / " +
                get(props, "productDetails.nnpa", ""),
            }
          : null,
        get(props, "productDetails.profitAfterTax", "")
          ? {
              key: "Profit After Tax",
              value: get(props, "productDetails.profitAfterTax", ""),
            }
          : null,
        get(props, "productDetails.debtEquityRatio", "")
          ? {
              key: "Debt / Equity Ratio",
              value: get(props, "productDetails.debtEquityRatio", ""),
            }
          : null,
      ],
    });
  }, [props]);

  const handleVideoClick = () => {
    toggleVideoModal();
  };

  const toggleVideoModal = () => {
    setShowVideo(!showVideo);
  };

  return (
    <div className={"about-icm " + props.classname}>
      <Row className="icm-about-row">
        <p className="main-title">{assetDetails?.title}</p>
        <div className="table-container">
          <Col
            lg={4}
            sm={11}
            xs={11}
            md={11}
            xl={4}
            className="img-div d-flex justify-content-center align-item-center"
          >
            <img
              src={props?.mldAssetDetails?.descLogoUrl}
              alt="InCred Financial Services"
            />
            {/* <div className="video-div">
              <div className="circle" onClick={() => handleVideoClick()}>
                <span class="mdi mdi-play"></span>
              </div>
            </div> */}
          </Col>
          <Col lg={8} sm={11} xs={11} md={11} xl={8}>
            {!isMobile && (
              <div className="about-table">
                {assetDetails?.lastArr.map(
                  (item, index) => (
                    console.log("item", item),
                    item ? (
                      <Col lg={3} key={index}>
                        <p className="text-muted mb-2">{item?.key}</p>
                        <p className="font-weight-semi-bold">{item?.value}</p>
                      </Col>
                    ) : null
                  )
                )}
              </div>
            )}
            {isMobile && (
              <div className="second-table-mob mt-3">
                {assetDetails?.lastArr.map((item, index) =>
                  item ? (
                    <Col md={6} sm={6} xs={6} key={index}>
                      <p className="navi-font-14 text-muted mb-0">
                        {item?.key}
                      </p>
                      <p className="navi-font-16 font-weight-medium">
                        {item?.value}
                      </p>
                    </Col>
                  ) : null
                )}
              </div>
            )}
            {console.log(assetDetails)}
            {!isMobile ? (
              <div className="desc-section d-flex mt-3">
                <Col>
                  <div style={{ width: "fit-content" }}>
                    <p
                      className="descTitle"
                      dangerouslySetInnerHTML={{
                        __html: assetDetails?.descTitle,
                      }}
                    />
                    <p className="description">{assetDetails?.description}</p>
                  </div>
                </Col>
                <Col className="description2-main">
                  <div className="description2">
                    {/* <ul> */}
                    {props?.mldAssetDetails?.bondId === "mld3" ? null : (
                      <li>
                        ISIN:{" "}
                        {mldAssetDetails?.trueISIN
                          ? mldAssetDetails.trueISIN
                          : "--"}{" "}
                      </li>
                    )}
                    <li>Original Mode of Issue: Private Issue</li>
                    {props?.mldAssetDetails?.bondId === "mld3" ? (
                      <li>Date of Issue: 1st Feb’24</li>
                    ) : props?.mldAssetDetails?.bondId === "mld4" ? (
                      <li>Date of Issue: 06 June 2024</li>
                    ) : props?.mldAssetDetails?.bondId === "mld5" ? (
                      <li>Date of Issue:  08th Oct 2025</li>
                    ) : props?.mldAssetDetails?.bondId === "gmldm0" ? (
                      <li>Date of Issue: 18th Jul’25</li>
                    ) : props?.mldAssetDetails?.bondId === "gmld1" ? (
                      <li>Date of Issue: 21st Jul’25</li>
                    ) : (
                      <li>Date of Issue: 11th Aug’23</li>
                    )}

                    {props?.mldAssetDetails?.bondId === "mld3" ? (
                      <li>Date of Credit Rating: 08-Dec-23</li>
                    ) : props?.mldAssetDetails?.bondId === "mld4" ? (
                      <li>Date of Credit Rating: 23 May 2024</li>
                    ) : props?.mldAssetDetails?.bondId === "mld5" ? (
                      <li>Date of Credit Rating: 06th Mar 2025</li>
                    ) : props?.mldAssetDetails?.bondId === "gmldm0" ? (
                      <li>Date of Credit Rating: 06-Mar-25</li>
                    ) : props?.mldAssetDetails?.bondId === "gmld1" ? (
                      <li>Date of Credit Rating: 06-Mar-25</li>
                    ) : (
                      <li>Date of Credit Rating: 01-Aug-23</li>
                    )}

                    <li> Returns: Floating</li>
                    <li>
                      Min. Returns {mldAssetDetails.minReturns}%
                    </li>
                    <li>
                      Max. Returns {mldAssetDetails?.maxReturns}%
                    </li>
                    <li>Debenture Trustee: Catalyst Trusteeship<br/> Limited (Formerly GDA Trusteeship Limited)</li>
                    {/* </ul> */}
                  </div>
                </Col>
              </div>
            ) : (
              <div>
                <Row>
                  <div style={{ width: "fit-content" }}>
                    <p
                      className="descTitle"
                      dangerouslySetInnerHTML={{
                        __html: assetDetails?.descTitle,
                      }}
                    />
                    <p className="description">{assetDetails?.description}</p>
                  </div>

                  <div className="description2 ml-4">
                    {/* <ul> */}
                    {props?.mldAssetDetails?.bondId === "mld3" ? null : (
                      <li>
                        ISIN:{" "}
                        {mldAssetDetails?.trueISIN
                          ? mldAssetDetails.trueISIN
                          : "--"}{" "}
                      </li>
                    )}
                    <li>Original Mode of Issue: Private Issue</li>
                    {props?.mldAssetDetails?.bondId === "mld3" ? (
                      <li>Date of Issue: 1st Feb’24</li>
                    ) : props?.mldAssetDetails?.bondId === "mld4" ? (
                      <li>Date of Issue: 06 June 2024</li>
                    ) : props?.mldAssetDetails?.bondId === "mld5" ? (
                      <li>Date of Issue: 08th Oct 2025</li>
                    ) : props?.mldAssetDetails?.bondId === "gmldm0" ? (
                      <li>Date of Issue: 18th Jul’25</li>
                    ) : props?.mldAssetDetails?.bondId === "gmld1" ? (
                      <li>Date of Issue: 21st Jul’25</li>
                    ): (
                      <li>Date of Issue: 11th Aug’23</li>
                    )}

                    {props?.mldAssetDetails?.bondId === "mld3" ? (
                      <li>Date of Credit Rating: 08-Dec-23</li>
                    ) : props?.mldAssetDetails?.bondId === "mld4" ? (
                      <li>Date of Credit Rating: 23 May 2024</li>
                    ) : props?.mldAssetDetails?.bondId === "mld5" ? (
                      <li>Date of Credit Rating: 06th Mar 2025</li>
                    ) : props?.mldAssetDetails?.bondId === "gmldm0" ? (
                      <li>Date of Credit Rating: 06-Mar-25</li>
                    ) : props?.mldAssetDetails?.bondId === "gmld1" ? (
                      <li>Date of Credit Rating: 06-Mar-25</li>
                    ): (
                      <li>Date of Credit Rating: 01-Aug-23</li>
                    )}
                    <li> Returns: Floating</li>
                    <li>
                      Yield: Min. Returns {mldAssetDetails.minReturns}%, Max.
                      Returns {mldAssetDetails?.maxReturns}%
                    </li>
                    <li>Debenture Trustee: Catalyst Trusteeship<br/> Limited (Formerly GDA Trusteeship Limited)</li>
                    {/* </ul> */}
                  </div>
                </Row>
              </div>
            )}
            <div
              className="btn-container text-align-center"
              style={props.isMobile ? { textAlign: "center" } : {}}
            >
              {props?.mldAssetDetails?.bondId === "gmldm0" || props?.mldAssetDetails?.bondId === "gmld1"  ? null :<Button
                className="invest-btn"
                onClick={() =>
                  window.open(mldAssetDetails?.companyPresentationLink, "_blank")
                }
              >
                Issuer Presentation
              </Button>}
            </div>
          </Col>
        </div>
      </Row>
      <VideoModal
        showVideo={showVideo}
        toggleVideoModal={toggleVideoModal}
        isMobile={props?.isMobile}
        showVideoOnly={true}
      />
    </div>
  );
}
